import get from 'lodash/get';

export default {
  props: {
    name: String,
  },

  data: () => ({
    dialog: false,
    params: {},
  }),

  mounted() {
    this.$dialog.register(this.name || this.$options.name, this);
  },

  beforeDestroy() {
    this.$dialog.unregister(this.name || this.$options.name);
  },

  methods: {
    async showDialog(params) {
      if (this.dialog) {
        this.dialog = false;
        return;
      }

      if (typeof get(this, 'beforeOpen') === 'function') {
        await this.beforeOpen(params);
      }

      this.dialog = true;
      this.params = params;
    },

    async hideDialog() {
      if (typeof get(this, 'beforeClose') === 'function') {
        await this.beforeClose();
      }

      this.dialog = false;
    },
  },
};
